import { render, staticRenderFns } from "./LoadingInfosPlugin.vue?vue&type=template&id=8e641832&scoped=true"
import script from "./LoadingInfosPlugin.vue?vue&type=script&lang=ts"
export * from "./LoadingInfosPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LoadingInfosPlugin.vue?vue&type=style&index=0&id=8e641832&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8e641832",
  null
  ,true
)

export default component.exports